import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';
import { PaymentsService } from '../../services/payments.service';

@Component({
    selector: 'app-two-cp-payment-portal',
    templateUrl: './two-cp-payment-portal.component.html',
    styleUrls: ['./two-cp-payment-portal.component.scss'],
    standalone: false
})
export class TwoCpPaymentPortalComponent {
  @Input() internId: string;
  @Output() is2CPPaymentAvailable = new EventEmitter<boolean>();
  sessionId: string;
  intacctCustomerPortalID: string;
  customerPortalId: string;
  customerPortalUrl: string;
  statusIsValid = false;
  loginStatus = false;
  showSpinner = true;
  paymentPortalURL: SafeUrl | undefined;

  constructor(private sanitizer: DomSanitizer,
              private configService: ConfigService,
              private paymentsService: PaymentsService
  ){}

  ngOnInit(): void {
    this.get2CPSessionData();
  }

  get2CPSessionData(): void {
    this.paymentsService.getSessionData(this.internId).subscribe((session: { sessionId: string; loginStatus: boolean; customerPortalId: string; intacctCustomerPortalID: string; portalURL: string; }) => {
      this.sessionId = session.sessionId;
      this.loginStatus = session.loginStatus;
      this.customerPortalId = session.customerPortalId;
      this.intacctCustomerPortalID = session.intacctCustomerPortalID;
      this.statusIsValid = true;
      let portalUrl: string = session.portalURL;
      let url = portalUrl + '/sso.aspx?id=' + this.intacctCustomerPortalID + '&gateway=' + this.configService.paymentGateway + '&cid=' + this.customerPortalId + '&sid=' + this.sessionId;
      this.customerPortalUrl = url;
      this.paymentPortalURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showSpinner = false;
      this.is2CPPaymentAvailable.emit(this.loginStatus);
    });
  }


}
